import React from 'react'
import SAISVG from '../../../../../../_template/helpers/CommonFunction';
import { getShortForm } from '../../../../../component/common/Helper';
const BusinessInfo = (props) => {
    const {profileData} = props;
    return (
        <>   
            <div className="row">
                <div className="col-md-12 mb-5">
                    <div className="card card-flush h-md-100 bg-gray-300">
                        <div className="card-body pb-5">
                            <div className="d-flex flex-wrap flex-sm-nowrap">
                                <div className="me-7 mb-4">
                                    <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative bg-light">
                                        {
                                            Object.keys(profileData.biz_logo).length !== 0 ?
                                            <img src={profileData.biz_logo.full_path} alt={profileData.business_name} />
                                            :
                                            <span
                                                className="symbol-label fs-3x fw-semibold text-primary bg-light-primary"
                                            >
                                                {getShortForm(profileData.business_name)}
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                        <div className="row w-100">
                                            <div className="col-md-10">
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex align-items-center">
                                                        <div className="text-primary fs-2 fw-bold me-1 text-uppercase">
                                                            {profileData?.business_name}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-wrap fw-semibold fs-5 text-gray-600">
                                                        Business id is 
                                                        <span className="text-primary mx-2">
                                                            {profileData?.business_id}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className="badge me-auto badge-light-dark">
                                                            {profileData?.biz_email}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-2 text-end p-0">
                                                <button 
                                                    className="btn btn-light btn-icon btn-sm" 
                                                    onClick={() => props.showUpdateForm(true)}
                                                >
                                                    <SAISVG 
                                                        path="media/icons/duotune/art/art005.svg" 
                                                        className="svg-icon-muted svg-icon-2" 
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap flex-stack">
                                        <div className="row w-100">
                                            <div className="col-md-6">
                                                <div className="min-w-125px py-3 px-4 h-md-100">
                                                    <div className="d-flex flex-stack m-d-block">
                                                        <div className="">
                                                            <div className="fw-bold fs-7 text-gray-600">
                                                                Business Address
                                                            </div>
                                                            <div className="d-flex align-items-center m-d-block">
                                                                <div className="fs-7 text-gray-800">
                                                                    {profileData?.business_address}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 pe-0">
                                                <div className="min-w-125px py-3 px-4 h-md-100">
                                                    <div className="d-flex flex-stack">
                                                        <div className="fw-bold fs-7 text-gray-600">
                                                            Primary Contact
                                                        </div>
                                                        <div className="d-flex align-items-senter">
                                                            <span className="text-gray-800">
                                                                {profileData?.biz_phone}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="separator separator-dashed my-3"></div>
                                                    <div className="d-flex flex-stack">
                                                        <div className="fw-bold fs-7 text-gray-600">
                                                            Secondary Contact
                                                        </div>
                                                        <div className="d-flex align-items-senter">
                                                            <span className="text-gray-800">
                                                                {profileData?.secondary_contact}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BusinessInfo